<template>
  <div>
    <page-header
      title="Edit User"
      breadcrumb="Dashboard > Users and Groups > Add User"
    />
    <div class="card">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="picture-upload-form text-center">
              <div class="my-3">
                <image-uploader
                  @input="handleImageUpload($event)"
                  @remove-image="removeImage"
                  :imageUrl="userDetails.imageurl"
                  :isUploadingImage="isUploadingImage"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="fname" class="label">First Name</label>
                <input
                  type="text"
                  class="input"
                  v-model="userDetails.firstname"
                  placeholder="-- Enter First Name --"
                />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="mname" class="label">Middle Name</label>
                <input
                  type="text"
                  class="input"
                  v-model="userDetails.middlename"
                  placeholder="-- Enter Middle Name --"
                />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="lname" class="label">Last Name</label>
                <input
                  type="text"
                  class="input"
                  v-model="userDetails.lastname"
                  placeholder="-- Enter Last Name --"
                />
              </div>
            </div>
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="gender" class="label">Gender</label>
                <el-select
                  v-model="userDetails.gender"
                  placeholder="-- Select --"
                >
                  <el-option
                    v-for="gender in genders"
                    :key="gender"
                    :label="gender"
                    :value="gender"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Work Email</label>
                <input
                  type="text"
                  class="input"
                  v-model="userDetails.email"
                  disabled
                />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Phone Number</label>
                <vue-tel-input v-model="userDetails.mobile_no"></vue-tel-input>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <label for="employment-type" class="label">Employment Type</label>
            <el-select v-model="userDetails.employmentType" placeholder="">
              <el-option
                v-for="employmentType in employmentTypes"
                :key="employmentType"
                :label="employmentType"
                :value="employmentType"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <hr />
      <div>
        <div class="new-user-form-location-and-priviledge-form">
          <div class="container-fluid">
            <div class="row mb-4">
              <div class="col-md-6 col-lg-4 col-12">
                <label class="label">Role</label>
                <el-select
                  filterable
                  v-model="userRole"
                  placeholder=""
                  @change="setUserRoles($event)"
                >
                  <el-option
                    value=""
                    >-- Select --
                  </el-option>
                  <el-option
                    v-for="role in roles"
                    :key="role.id"
                    :value="role.id"
                    :label="role.name"
                  >
                  </el-option>
                </el-select>
                
              </div>
              <div class="col-md-6 col-lg-4 col-12" id="fleet">
                <label class="label">Fleet</label>

                <el-select
                  filterable
                  v-model="userDetails.fleets"
                  placeholder=""
                >
                  <el-option
                    value=""
                    >-- Select --
                  </el-option>
                  <el-option
                    v-for="fleet in fleets"
                    :key="fleet.id"
                    :value="fleet.id"
                    :label="fleet.equipment + '/' + fleet.fleetReference"
                  >
                  </el-option>
                </el-select>

              </div>

              <div class="col-md-6 col-lg-4 col-12">
        
                <label class="label">Location</label>
                <el-select
                  multiple
                  filterable
                  @remove-tag="removeLocation($event)"
                  v-model="selectedLocation"
                  placeholder=""
                >
                  <el-option
                    value=""
                    >-- Select --
                  </el-option>
                  <el-option
                    v-for="location in allLocations"
                    :key="location.id"
                    :label="location.locationName"
                    :value="location.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="show">
          <advanced-details-form />
        </div>
      </div>
      <div>

      <div
        class="new-user-form-location-and-priviledge-form"
       
      >
      <div class="continer-fluid">

      
      </div>
        
      </div>
      </div>

      <div v-if="show">
        <advanced-details-form />
      </div>
      <div class="flex my-5 items-center justify-between">
        <div class="cursor-pointer" @click="$router.go(-1)">
          <p>Cancel</p>
        </div>
        <primary-button
          buttonText="Update User"
          :disabled="disableButton"
          @click="updateUser"
          :loading="updatingUser"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import AdvancedDetailsForm from "@/components/3pl/Users/AdvancedDetailsForm";
import ImageUploader from "@/components/3pl/Users/ImageUploader";
import PageHeader from "@/components/UI/NewPageHeader";
export default {
  components: {
    AdvancedDetailsForm,
    PageHeader,
    ImageUploader,
  },
  data() {
    return {
      search: "",
      show: false,
      roleId: "",
      loading:false,
      selectedLocation: [],
      selectedRoute: [],
      userDetails: {
        firstname: "",
        middlename: "",
        lastname: "",
        gender: "",
        email: "",
        mobile_no: "",
        employmentType: "",
        roles: "",
        roleInfo: {
          roleId: "",
          roleName: "",
        }
      },
      allLocations: [],
      routes: [],
      fleets: [],

      role: {
        appSlug: "",
        roleId: "",
      },
      userRoutes: [],
      userRole: null,
      userRoleObj: {},
      locations: [],
      genders: ["Male", "Female"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      updatingUser: false,
      roles: [],
      isUploadingImage: false,
    };
  },


  computed: {
      dateFilterpayload() {
              return {
                dateFilter: "custom",
                startDate: "2024-01-01",
                endDate: this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
              };
            },
    criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      // Filter out already selected options
      const options = this.options.filter(
        (opt) => this.value.indexOf(opt) === -1
      );
      if (criteria) {
        // Show only options that match criteria
        return options.filter(
          (opt) => opt.toLowerCase().indexOf(criteria) > -1
        );
      }
      // Show all options available
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return "There are no tags matching your search criteria";
      }
      return "";
    },
    disableButton() {
      return this.shouldDisableButton(this.user);
    },
  },
  async mounted() {
      
    this.loading =true
    await this.getRoles();
    await this.getFleets();
    await this.getUser();
    await this.getAllLocations();
    await this.getRoutes();
    await this.getUserDetails();
    await this.getUserLocation();
    await this.getUserRoutes();
    await this.setRole();
    
  },
  methods: {
    async removeLocation(val) {
      try {
        let payload = {
          userId: this.userDetails.id,
          locationId: val,
        };
        console.log(JSON.stringify(payload, null, 2));
        const response = await this.$_deleteUserLocation(payload);
        console.log(JSON.stringify(response, null, 2));
      } catch (error) {
        this.handleError(error);
      }
    },
    async removeRoute(val) {
      try {
        let payload = {
          shippingServiceId: val,
          userId: this.userDetails.id,
        };
        console.log(JSON.stringify(payload, null, 2));
        const response = await this.$_deleteUserRoute(payload);
        console.log(JSON.stringify(response, null, 2));
      } catch (error) {
        this.handleError(error);
      }
    },
    setUserRoles(event){
     
      let role = this.roles.find(x => x.id == event)
      
      this.userRoleObj = {
        roleId : event,
        roleName: role.name
      }
    },

    async getFleets() {
      try {
        let response = await this.$_getAllFleets();
        this.fleets = response.data.data.fleet;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllLocations() {
      try {
        let response = await this.$_getAll3plLocations();

        this.allLocations = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getRoutes() {
      try {
        let response = await this.$_getAllRoutes();
        this.routes = response.data.data.shippingServices.filter(
          (route) =>
            route.terminalType != "terminal-to-door" &&
            route.terminalType != "door-to-door"
        );
      } catch (error) {
        this.handleError(error);
      }
    },
    selectRole(role) {
      let selectedRole = this.roles.find((rle) => rle.id == role);
      this.role.appSlug = selectedRole.appSlug;
      this.role.roleId = selectedRole.id;
      // console.log(this.user, role, selectedRole, "success");
    },
    async getUserDetails() {
      try {
        let userId = this.$route.params.id;
        let response = await this.$_getSingleUser(userId);
      
        this.userDetails = response.data.user;
        this.saveUserDetails(response.data.user);
      } catch (error) {
        this.handleError(error);
        console.log(error);
      }
    },
    getUser() {
      this.user = this.userDetails;
    },
    shouldDisableButton(user) {
      if (user) return false;
    },
    saveUserDetails(user) {
      this.user.fname = user.fname;
      this.user.mname = user.mname;
      this.user.lname = user.lname;
      this.user.gender = user.gender;
      this.user.email = user.email;
      this.user.phoneNo = user.phoneNo;
      this.user.employmentType = user.employmentType;
      this.user.roles = user.roles;
      this.user.role.roleId = user.optimaRole;
      this.user.role.appSlug = "";
      this.user.id = user.id;
    },
    async getUserLocation() {
      try {
        let response = await this.$_getUserLocation(this.userDetails.id);
        console.log(JSON.stringify(response.data.data, null, 2));
        this.locations = response.data.data;
        this.setLocation();
      } catch (error) {
        this.handleError;
      }
    },
    async getUserRoutes() {
      try {
        let response = await this.$_getUserRoutes(this.userDetails.id);
        this.userRoutes = response.data.routeUsers;
        this.setRoute();
      } catch (error) {
        this.handleError;
      }
    },
    setLocation() {
      if (this.locations) {
        let location = this.locations.map((location) => location.location.id);
        console.log(JSON.stringify(location, null, 2));
        this.selectedLocation = location;
      }
    },
    setRoute() {
      if (this.userRoutes) {
        let route = this.userRoutes.map((route) => route.shippingService.id);
        //  console.log(JSON.stringify(route, null, 2))
        this.selectedRoute = route;
      }
    },
    async updateUser() {
      this.updatingUser = true;
      try {
        let userDetails = {
          // imageUrl: this.userDetails.imageurl,
          firstname: this.userDetails.firstname,
          // middlename: this.userDetails.middlename,
          lastname: this.userDetails.lastname,
          // gender: this.userDetails.gender,
          email: this.userDetails.email,
          // mobile_no: this.userDetails.mobile_no,
          phone: this.userDetails.mobile_no,
          // employmentType: this.userDetails.employmentType,
          role: {
            // appSlug: "muleex",
            roleId: this.userRoleObj.roleId,
            // roleName: this.userRoleObj.roleName,
          },
          locations: this.selectedLocation,
          fleet: this.userDetails.fleets,
          routes: this.selectedRoute,
        };
        console.log(JSON.stringify(userDetails, null, 2));
        let response = await this.$_updateUser(
          userDetails,
          this.userDetails.id
        );
        console.log(response);
        this.generateToast("User successfully updated", "success");
        this.resetUser();
        this.$store.dispatch("resetUserList");
        setTimeout(() => {
          this.$router.push({ name: "UsersAndGroups" });
        }, 500);
      } catch (error) {
        this.handleError(error);
        this.updatingUser = false;
      }
    },
    getUserId() {
      let userId = localStorage.getItem("userId");
      if (userId) {
        console.log(userId);
        this.getUserDetails(userId);
      } else {
        this.$router.push({ name: "UsersAndGroups" });
      }
    },
    async getRoles() {
      try {
        let response = await this.$_getRoles(this.dateFilterpayload);
        this.roles = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    onUpdateUser() {
      this.updatingUser = false;
      this.generateToast("User has successfully been created", "success");
      this.resetUser();
      this.$router.push("/settings/users-and-groups");
    },
    resetUser() {
      this.user = {
        fname: "",
        mname: "",
        lname: "",
        gender: "",
        email: "",
        phoneNo: "",
        employmentType: "",
        roles: "",
      };
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.user.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.user.imageurl = null;
    },
  
    
      async setRole() {
      
      if (this.userDetails.roleInfo !== "") {
        // this.userRole = JSON.parse(this.userDetails.roles).roleName
         this.userRole = this.userDetails.roleInfo.roleName
        this.userRoleObj = {
          roleId: JSON.parse(this.userDetails.roleInfo).roleId,
          roleName: JSON.parse(this.userDetails.roleInfo).roleName,
        };
        this.loading =true
      }
    },
  },
};
</script>

<style scoped>
.max-h-zero {
  max-height: 0;
}
.routes-container {
  animation: 3s 1 linear pop-height;
}
@keyframes pop-height {
  from {
    max-height: 0;
  }
  to {
    max-height: 100vh;
  }
}
.picture-upload-form {
  /* border: 1px solid #edf2ef; */
  border-radius: 10px;
  padding: 1.55rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.user-img {
  width: 10rem;
  margin: 1.5rem auto;
}
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.label {
  font-size: 0.9rem;
}
.input {
  margin-bottom: 0.5rem;
}
.new-user-form__col-three {
  padding-top: 1.25rem;
}
hr {
  margin: 2rem 0;
}

.input-row {
  width: 100%;
  display: flex;
}
.input-row > div {
  width: 100%;
  padding-right: 1rem;
}
@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }
  .input-row div {
    width: 100%;
  }
}
</style>
